"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { LevelKeysConflictContext } from './use-level-keys-conflicts.mjs';

const LevelKeysConflictProvider = LevelKeysConflictContext.Provider;

export { LevelKeysConflictProvider };
